module.exports = __webpack_public_path__ + "img/avatar6.08d93a7c.png";